import Repository from './Repository'

export default {
  getHistorialResponses (params) {
    return Repository.private().get(
      'dashboard/users/status',
      {
        params: params
      }
    )
  },
  urlDownloadCSV (paramsFilters) {
    return Repository.baseURL() + 'dashboard/users/status/csv' + paramsFilters
  }
}
